<template>
  <rest-list :payload="fetchEndpoint" @dataLoaded="setData($event)">
    <template v-if="data[0]">
      <rest-list-column
        prop="title"
        :title="$t('CampaignChannelAnalytics_Table_Variant')"
        :min-width="200"
        :sortable="false"
        :filter-input="false"
        fixed
      >
        <template slot-scope="scope">
          <i class="el-icon-trophy" v-if="scope.row.fields.key === 'W'" />
          {{ variantLabel(scope.row, true) }}
          <i
            v-if="parseInt(scope.row.fields.winner)"
            class="winner el-icon-trophy"
          />
        </template>
      </rest-list-column>
      <rest-list-column
        v-if="hasCustomVariantsShare"
        prop="fields.split_percentage"
        :title="$t('CampaignChannelAnalytics_Table_Variant_Split_Percentage')"
        :min-width="200"
        :filter-input="false"
        :sortable="false"
        fixed
      >
        <template v-slot="scope">
          {{ scope.row.fields.split_percentage }}
        </template>
      </rest-list-column>
      <template v-for="(metricGroup, metricIndex) in data[0].metricGroups">
        <rest-metric-column
          v-for="(metric, index) in metricGroup.metrics"
          :key="metric.name"
          :prop="'metricGroups[' + metricIndex + ']'"
          :metric-group="metricGroup"
          :index="index"
          :metric="metric"
          :sortable="false"
        >
        </rest-metric-column>
      </template>
    </template>
  </rest-list>
</template>

<script>
import RestList from '@/common/components/rest/RestList'
import RestListColumn from '@/common/components/rest/RestListColumn'
import RestMetricColumn from '@/common/components/rest/RestMetricColumn'
import { projectEndpoint } from '@/core/helpers'

export default {
  name: 'VariantsTable',

  components: { RestMetricColumn, RestListColumn, RestList },

  props: {
    channel: {
      type: String,
      required: true
    },

    analyticsDateRange: {
      type: Object,
      required: true
    },

    hasCustomVariantsShare: {
      type: Boolean,
      required: true
    }
  },

  data() {
    return {
      data: []
    }
  },

  methods: {
    setData(event) {
      this.data = event
    },
    variantLabel(row, withoutW = false) {
      let label = row.fields.key
      if (withoutW && row.fields.key === 'W') {
        label = ''
      }

      if (row.fields.title && row.fields.title.length) {
        label += ' – ' + row.fields.title
      }
      if (row.fields.action && row.fields.action.length) {
        label += ' – ' + row.fields.action
      }
      return label
    }
  },

  computed: {
    campaignId() {
      return this.$route.query.id || null
    },

    fetchEndpoint() {
      return projectEndpoint({
        method: 'get',
        url: `campaigns/${this.campaignId}/analytics/${this.channel}`,
        params: {
          date_from: this.analyticsDateRange.date_from,
          date_to: this.analyticsDateRange.date_to
        }
      })
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/modules/campaign-manage/components/analytics/VariantsTable.vue